import { Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { formatDate } from "../../../../ui library/helpers/functions";
import DynamicTable from "../modules/DynamicSection/components/DynamicTable";

const Referrals = ({
  currentReferrals = [],
  label,
  schema,
  sectionId,
  showAddButton = false,
  questionKey,
  handleAnswerChange,
  setEnableSave,
}) => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData([]);
  }, [currentReferrals]);

  useEffect(() => {
    const changes = tableData.length > 0 ? tableData : undefined;
    handleAnswerChange(questionKey, changes);
  }, [tableData]);

  return (
    <>
      <DynamicTable
        addButtonText="Add Referrals"
        showAddButton={showAddButton}
        label={label}
        editableFields={["all"]}
        setTableData={setTableData}
        tableData={tableData}
        sectionId={sectionId}
        schema={schema}
        columns={["referral_from", "referral_to", "provider_type", "referred_at", "source"]}
        setEnableSave={setEnableSave}
        isReferrals
      />

      <div className="mb-4 grid w-full">
        <Typography fontWeight="medium">Current Referrals: </Typography>
        <ul className="list-disc px-8 py-4">
          {currentReferrals.map((referral, refIdx) => (
            <li key={refIdx}>
              <b className="mr-2">From:</b>
              <span>{referral.referral_from}</span>
              {" - "}
              <b className="mr-2">To:</b>
              <span>{referral.referral_to}</span>
              {" - "}
              <span>{formatDate(referral.referred_at)}</span>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Referrals;
